import React from 'react';
import i18n from '../../i18n';

const renderErrors = (errors) => {
    return errors.map((error, index) =>
        React.isValidElement(error) ? error : <span key={index} className="form-field-error">{i18n.t(error)}</span>
    )
}

export const getFieldErrors = (field, errors) => (errors && errors?.[field]) ? renderErrors(errors[field]) : undefined
export const getFieldStatus = (field, errors) => (errors && errors?.[field]) ? "error" : undefined
